import { useQuery } from '@tanstack/react-query';

import { getTestimonials, type ListTestimonialsParams } from '../../api/testimonials';
import { useAuth } from '../auth/AuthProvider';

export function useTestimonials(params: ListTestimonialsParams = {}) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['testimonials', params.limit ?? null, params.offset ?? null],
    queryFn: () => getTestimonials(tokens!.access_token, params),
    enabled: Boolean(tokens?.access_token),
  });
}
